








import { defineComponent } from '@vue/composition-api';
import useJobStatus from '@/use/useJobStatus';

const JobStatusRenderer = defineComponent({
  props: {
    targetDate: { required: true },
    status: { type: String, default: 'PENDING' },
  },
  setup() {
    const { dueDateDisplay, statusClassMap, getColor } = useJobStatus();
    return {
      dueDateDisplay,
      statusClassMap,
      getColor,
    };
  },
});

export default JobStatusRenderer;
